export default class Trip {
  description = "";
  destination = "";
  dateStart = null;
  dateEnd = null;
  isSelfBook = true;
  flights = [];
  properties = [];
  travelers = [];
}
